export default "__VITE_ASSET__BgFqBKy___"